import React from "react";
import { Gem } from "lucide-react";
import { useNavigate } from "react-router-dom";

export interface UpgradeToSeeMoreButtonProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent) => void;
  size?: "sm" | "md" | "lg";
}

export default function UpgradeToSeeMoreButton({
  className = "",
  style,
  onClick,
  size = "md",
}: UpgradeToSeeMoreButtonProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (onClick) {
      onClick(e);
    } else {
      navigate("/subscription");
    }
  };

  const sizeClasses =
    size === "sm"
      ? "px-3 py-1.5 text-xs gap-1.5"
      : size === "lg"
      ? "px-6 py-3 text-sm gap-2"
      : "px-4 py-2 text-[13px] gap-2";

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center justify-center font-medium rounded-md transition-all duration-150 cursor-pointer shadow-sm active:scale-95 select-none ${sizeClasses} ${className}`}
      style={{
        backgroundColor: "#f5b738",
        color: "#78350E",
        border: "1px solid #e0a328",
        boxShadow: "0 2px 8px rgba(245, 183, 56, 0.25)",
        ...style,
      }}
    >
      <Gem size={size === "sm" ? 13 : 15} color="#78350E" className="shrink-0 stroke-[1.8]" />
      <span className="tracking-tight whitespace-nowrap font-medium" style={{ color: "#78350E" }}>Upgrade to see more data</span>
    </button>
  );
}
